import { Component, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MenuComponent } from "../../components/menu/menu.component";
import { ApiService, CommonFunctionsService, DatastoreService } from '../../services';
import { CommunicationService } from '../../services/communication.service';
import { NgxSpinnerService } from "ngx-spinner";
import { FormControl, FormGroup, Validators } from '@angular/forms';
import moment from 'moment-timezone';

@Component({
  selector: 'app-communication',
  templateUrl: './communication.component.html',
  styleUrls: ['./communication.component.scss']
})
export class CommunicationComponent implements OnInit, OnChanges {

  config: any;
  site = "";
  companyDetails: any;
  booking:any;
  activeThread: any;
  messages: any = [];
  member: any;
  sendingMessage = false;
  sendingForm: FormGroup;
  sendingFormCategories: string[] = [];
  sendingFormSubmitted = false;

  constructor(
    private route: ActivatedRoute,
    private dataStore: DatastoreService,
    private commonFunctionsService: CommonFunctionsService,
    private apiService: ApiService,
    private spinner: NgxSpinnerService,
    private router: Router,
    private comms: CommunicationService
  ) { }

  ngOnInit(): void {
    const configStr = this.dataStore.config;
    this.config = JSON.parse(configStr);
    console.log(this.config);
    this.route.params.subscribe(async params => {
      await this.commonFunctionsService.setCompanyName(params);
      this.site = params.site;
      if (!this.booking) {
        const bookingStr = localStorage.getItem('ceremony') as string;
        this.booking = JSON.parse(bookingStr);
      }

      this.getMessages();
      this.comms.newMessage.subscribe(message => {
        // new message
        console.log(message);
        console.log(`marking message ${message.message_id} as read`);
        this.checkMessageStatus(message);
      });
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
      console.log(changes);
  }

  get form() {
    return this.sendingForm.controls;
  }

  async getMessages() {
    // get the thread for this booking, then get all messages in the thread
    try {
      this.member = this.dataStore.member;
      const threads: any = await this.apiService.getThreadsForBooking(this.booking.company_id, this.booking.id );
      console.log(threads);
      this.dataStore.messageThreads = threads;
      if (threads.length > 0) {
        this.activeThread = threads[0];
        this.dataStore.activeThread = threads[0];
        // now get messages
        this.messages = await this.apiService.getMessagesInThread(this.booking.company_id, this.activeThread.thread_id, false);
        this.dataStore.messagesOnActiveThread = this.messages;

        for (const message of this.messages) {
          await this.checkMessageStatus(message);
        }
      }
    }
    catch (err) {
      console.error(err);
    }
  }

  openSendMessage() {
    this.sendingMessage = true;
    this.sendingFormSubmitted = false;

    this.sendingForm = new FormGroup({});
    const messageControl = new FormControl('', [Validators.required]);
    const agreeControl = new FormControl(false, [Validators.requiredTrue]);


    this.sendingFormCategories = [];
    if (this.config.hasOwnProperty('myCeremony')) {
      if (this.config.myCeremony.hasOwnProperty('communication')) {
        if (this.config.myCeremony.communication.hasOwnProperty('messageForm')) {
          if (this.config.myCeremony.communication.messageForm.hasOwnProperty('categories')) {
            if (this.config.myCeremony.communication.messageForm.categories && this.config.myCeremony.communication.messageForm.categories.length > 0) {
              this.config.myCeremony.communication.messageForm.categories.forEach(element => {
                this.sendingFormCategories.push(element);
              });
            }
          }
        }
      }
    }

    // Non-stat bookings neither give notice nor receive certificates, so
    // those message categories are hidden from the dropdown. Non-stat
    // detection reuses the give-notice hideMenuFromServiceIds config list —
    // the same list the menu and checklist use to hide Give Notice.
    if (this.isNonStatBooking()) {
      const hiddenCategories = ['certificate', 'give notice'];
      this.sendingFormCategories = this.sendingFormCategories.filter(
        (category) =>
          !hiddenCategories.some((hidden) =>
            String(category).toLowerCase().includes(hidden),
          ),
      );
    }

    this.sendingForm.addControl('message', messageControl);
    this.sendingForm.addControl('agree', agreeControl);

    if (this.sendingFormCategories.length > 0) {
      const categoriesControl = new FormControl('', [Validators.required]);
      this.sendingForm.addControl('category', categoriesControl);
    }

  }

  /**
   * Whether the booking's service is in the give-notice
   * hideMenuFromServiceIds config list — the app's working definition of a
   * non-stat booking (RWRSPI-989). Matches on booking.service_id (as the
   * menu/checklist do) or the selected service's global_id, since a
   * rescheduled booking's service_id is the write id (catalogue id + 1).
   */
  private isNonStatBooking(): boolean {
    const ids = this.config?.myCeremony?.['give-notice']?.rules?.hideMenuFromServiceIds;
    if (!Array.isArray(ids) || ids.length === 0) {
      return false;
    }
    const bookingServiceId = Number(this.booking?.service_id);
    const globalServiceId = Number(this.dataStore.selectedService?.global_id);
    return ids.some(
      (id: any) => Number(id) === bookingServiceId || Number(id) === globalServiceId,
    );
  }

  async sendMessage() {
    this.sendingFormSubmitted = true;
    this.sendingForm.markAsTouched();
    if (this.sendingForm.valid) {
      const message = this.sendingForm.controls['message'].value;
      let category = '';
      if (this.sendingFormCategories.length > 0) {
        category = this.sendingForm.controls['category'].value;
      }
      console.log('category', category, this.sendingForm.controls['category']);
      if (this.dataStore.messageThreads.length > 0) {
        const newMsg:any = await this.apiService.sendMessageToThread(this.booking.company_id, this.activeThread.thread_id, message, this.booking.id, category);
        this.dataStore.messagesOnActiveThread.unshift(newMsg);
      }
      else {
        const newMsg:any = await this.apiService.sendNewMessage(this.booking.company_id, this.booking.id, message, category);
        if (!this.dataStore.messagesOnActiveThread) {
          this.dataStore.messagesOnActiveThread = [];
        }
        this.dataStore.messagesOnActiveThread.unshift(newMsg);
      }

      this.sendingMessage = false;
      this.getMessages();
      this.apiService.sendNotificationEmail(this.booking);
    }
    else {
      this.sendingForm.get('agree').updateValueAndValidity({onlySelf: true});
    }

  }

  async checkMessageStatus(message: any) {
    console.log('Read state:', message.read_at, 'Sender', message.sender_id, 'User', this.booking.id);
    if (message.sender_id != this.booking.id) {
      if (!message.read_at) {
        console.log(`marking message ${message.message_id} as read`);
        message.read_at = moment().utc().tz('Europe/London').format('YYYY-MM-DDTHH:mm:ss');
        await this.apiService.markMessageAsRead(this.booking.company_id, this.activeThread.thread_id, message.message_id);
      }
    }
  }

  closeMessage() {
    this.sendingMessage = false;
  }

}
